import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Preloader } from "@/components/Preloader";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { PriceList } from "@/components/PriceList";
import { GallerySection } from "@/components/GallerySection";
import { BookingSection } from "@/components/BookingSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";

const DEFAULT_CONTENT = {
  hero_overline: "AUGSTAS VEIKTSPĒJAS AUTOSERVISS",
  hero_title_line1: "PROFESIONĀLS SERVISS",
  hero_title_line2: "TAVAM AUTO!",
  hero_subtitle: "Diagnostika, dzinēja remonts, metināšana, bremzes un apkopes darbi.",
  phone: "20 342 424",
  email: "info@turbolux.lv",
  address: "Rīga, Latvija",
  hours_weekday: "P – Pk: 09:00 – 19:00",
  hours_saturday: "Se: 10:00 – 15:00",
  hours_sunday: "Sv: Slēgts",
  announcement: "Bezmaksas datordiagnostika, veicot apkopi TURBOLUX servisā.",
  about_title: "MĒS DZĪVOJAM AR SPIEDIENU",
  about_text: "TURBOLUX AUTOSERVISS — precizitāte, oriģinālas detaļas un rakstiska garantija.",
};

export default function Home() {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [services, setServices] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [prices, setPrices] = useState([]);
  const [picked, setPicked] = useState([]);

  const addJob = (job) => setPicked((p) => (p.some((x) => x.key === job.key) ? p : [...p, job]));

  useEffect(() => {
    api.get("/content").then(({ data }) => setContent({ ...DEFAULT_CONTENT, ...data })).catch(() => {});
    api.get("/services").then(({ data }) => setServices(data)).catch(() => {});
    api.get("/gallery").then(({ data }) => setGallery(data)).catch(() => {});
    api.get("/prices").then(({ data }) => setPrices(data)).catch(() => {});
  }, []);

  return (
    <div className="relative min-h-screen bg-[#08080a]">
      <Preloader />
      <Nav phone={content.phone} />
      <Hero content={content} services={services} />
      <Marquee />
      <PriceList categories={prices} picked={picked} onAdd={addJob} />
      <Manifesto content={content} />
      <GallerySection items={gallery} />
      <BookingSection priceCategories={prices} picked={picked} setPicked={setPicked} />
      <ContactSection content={content} />
      <Footer content={content} />
    </div>
  );
}
